var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWaveFigure = function SvgWaveFigure(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 830 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M404.156 325C706.812 285 828.278 65.5 840 1V531H1C8.42916 485.833 101.5 365 404.156 325Z",
    fill: "#186346",
    stroke: "#186346"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWaveFigure);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,IDxzdmcgdmlld0JveD0iMCAwIDgzMCA1MjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgPHBhdGgKICAgICAgICAgIGQ9Ik00MDQuMTU2IDMyNUM3MDYuODEyIDI4NSA4MjguMjc4IDY1LjUgODQwIDFWNTMxSDFDOC40MjkxNiA0ODUuODMzIDEwMS41IDM2NSA0MDQuMTU2IDMyNVoiCiAgICAgICAgICBmaWxsPSIjMTg2MzQ2IgogICAgICAgICAgc3Ryb2tlPSIjMTg2MzQ2IgogICAgICAgIC8+Cjwvc3ZnPg==";